import { createContext } from "react";

export const CartContext = createContext({
  cart: [],
  cost: {
    subTotal: 0,
    tax: 0,
    total: 0,
  },
  addToCart: () => {},
  removeFromCart: () => {},
  clearCart: () => {},
  increment: () => {},
  decrement: () => {},
  updateProducts: () => {},
});
